import React, { useState } from 'react';

import { Provider } from './context';

export default function LiveAnnouncerProvider({ children }: { children: React.ReactNode }) {
  const [messagePolite, setMessagePolite] = useState<string>('');
  const [messageAssertive, setMessageAssertive] = useState<string>('');

  const announcePolite = (newMessage: string) => {
    // Screen reader will not register the change if the message is the same as the current one.
    // When the content is cleared the removed message is announced.
    if (messagePolite === newMessage) {
      setMessagePolite('');
    } else {
      setMessagePolite(newMessage);
    }
  };

  const announceAssertive = (newMessage: string) => {
    // Screen reader will not register the change if the message is the same as the current one.
    // When the content is cleared the removed message is announced.
    if (messageAssertive === newMessage) {
      setMessageAssertive('');
    } else {
      setMessageAssertive(newMessage);
    }
  };

  return <Provider value={{ messagePolite, messageAssertive, announcePolite, announceAssertive }}>{children}</Provider>;
}
